import store from '@/store';
import {LoginTypes} from '@/enums/LoginTypes.enum';
import {PortalMode, resolvePortalMode, TEACHER_PORTAL_KEY} from '@/helpers/portalMode';

export * from '@/helpers/portalMode';

/** Interface of the logged in user (see resolvePortalMode) */
export function portalMode(): PortalMode {
    return resolvePortalMode({
        userType: store.state.userType,
        guiAccess: store.state.guiAccess,
        isApplicant: (store.state.user as { isApplicant?: boolean } | null)?.isApplicant,
    });
}

/** Login may open the Lehrkraft-Bereich (teacher-only logins and office logins with the teacher role) */
export function hasTeacherPortal(): boolean {
    return store.state.userType === LoginTypes.EMPLOYEE && (store.state.guiAccess || []).includes(TEACHER_PORTAL_KEY as any);
}

/** Office login (office menu keys): office interface, messenger, send defaults, QM rights of the office … */
export function hasOfficeAccess(): boolean {
    return portalMode() === 'office';
}
